import { useEffect, useRef } from "react";
import * as d3 from "d3";

export type Point = [number, number]

export interface ILineData {
    points: Point[],
    name: string,
    color: string,
    design_value: number
}

export interface ILineProps {
    data: ILineData,
    scaleY: any,
    scaleX: any
}


export default function Area({ data, scaleX, scaleY }: ILineProps) {
    const ref = useRef<SVGGElement>(null);

    useEffect(() => {
        if (ref.current) {


            d3.select(ref.current).selectAll("*").remove();

            // reduce the amount of data we are showing

            // for each datapoint
            // is it within some bounds of another point? Check inside of a a list which should allow me to reduce the amount of items? I can work on a more efficient data structure later

            const new_data: Point[] = [];
            const radius = 2;
            for (let point of data.points) {
                let found_existing_point = false;
                for (let new_point of new_data) {

                    // Is it within the radius of another point?
                    if (Math.abs(scaleX(point[0]) - scaleX(new_point[0])) < radius / 3) {
                        if (Math.abs(scaleY(point[1]) - scaleY(new_point[1])) < radius / 3) {
                            found_existing_point = true;
                        }
                    }
                }
                if (!found_existing_point)
                    new_data.push(point);
            }

            d3.select(ref.current)
                .selectAll("dot")
                .data(new_data)
                .enter()
                .append("circle")
                .attr("cx", function(d) { return scaleX(d[0]); })
                .attr("cy", function(d) { return scaleY(d[1]); })
                .attr("clip-path", "url(#clip)")
                .attr("r", radius)
                .style("fill", data.color)

            d3.select(ref.current)
                .selectAll("dot")
                .data(new_data)
                .enter()
                .append("circle")
                .attr("cx", function(d) { return scaleX(d[0]); })
                .attr("cy", function(d) { return scaleY(d[1] / data.design_value); })
                .attr("clip-path", "url(#clip)")
                .attr("r", radius)
                .style("fill", data.color)


            var line = d3.line()
                .x(function(d) { return scaleX(d[0]) })
                .y(function(d) { return scaleY(d[1]) });

            var design_line = d3.line()
                .x(function(d) { return scaleX(d[0]) })
                .y(function(d) { return scaleY(d[1] / data.design_value) });



            var group = [{
                name: data.name,
                values: new_data
            }]

            d3.select(ref.current)
                .selectAll("connected_dots")
                .data(group)
                .enter()
                .append("path")
                .attr("clip-path", "url(#clip)")
                .attr("d", function(d) { return line(d.values) })
                .attr("stroke-width", radius)
                .style("stroke", data.color)
                .style("fill", "none")


            d3.select(ref.current)
                .selectAll("connected_dots")
                .data(group)
                .enter()
                .append("path")
                .attr("clip-path", "url(#clip)")
                .attr("d", function(d) { return design_line(d.values) })
                .attr("stroke-width", radius)
                .style("stroke", data.color)
                .style("fill", "none")
                .style("stroke-dasharray", ("10, 5"))

            let area_generator = d3.area()
                .x(d => scaleX(d[0]))
                .y0(d => scaleY(d[1] / data.design_value))
                .y1(d => scaleY(d[1]))

            d3.select(ref.current)
                .selectAll("connected_dots")
                .data(group)
                .enter()
                .append("path")
                .attr("d", function(d) { return area_generator(d.values); })
                .style("fill", data.color)
                .style("stroke", "black")
                .style("opacity", "0.5")


        }
    }, [data, scaleX, scaleY]);

    return <g ref={ref} />;
}
